import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'core-component',
  template: 'CoreComponent'
})
export class  CoreComponent implements OnInit, OnDestroy, OnChanges {

  protected initialized: boolean = false;
  protected busy: boolean = false;

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }


}
